/**
 * @fileoverview GET handler for the "/deliverability/postmaster/:app_group_id/compliance_status" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { deliverabilityPostmasterAppGroupIdComplianceStatus } from "./constants";
import type { DeliverabilityPostmasterComplianceStatusResult } from "./types";
import { isDeliverabilityPostmasterComplianceStatusResult } from "./validators";

export const getDeliverabilityPostmasterAppGroupIdComplianceStatus = reactQueryFetcherAdapter(
  deliverabilityPostmasterAppGroupIdComplianceStatus,
  (signal: AbortSignal, appGroupId: string): Promise<DeliverabilityPostmasterComplianceStatusResult> => {
    return fetch(`/deliverability/postmaster/${appGroupId}/compliance_status`, "GET", {}, { signal });
  },
  isDeliverabilityPostmasterComplianceStatusResult
);
